<template>
  <div>
    <page-header
      title="Quotes & Drafts"
      breadcrumb="Billings & Payments > My Transactions"
    />
    <section class="bg-white my-4 p-3">
      <div class="flex py-4 justify-between">
        <div class="unit-point w-full md:w-6/12">
          <p class="w-full">Document Count: {{ allQuotes.totalCount }}</p>

          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
      </div>

      <div class="flex items-center justify-between py-2">
        <i class="px-4 py-4">All unprocessed quotes and drafts will be removed from the
           register three months after their creation.</i>
        <RouterLink to="/new-quote-draft"
          ><button class="get-quote">Get New Quote</button></RouterLink
        >
      </div>
      <TableFilter @setSearchTerm = "sortSearchString" @filterProps="filterProps" @setQueryparams="sortItemProps" :bookings="allQuotes.shippings" />
     
      <div v-loading="isLoading">
        <QuoteTable :quotes="allQuotes.shippings" />
      </div>

      <PaginationControl
        :total="allQuotes.totalCount"
        :pageNumber="pageNumber"
        @pageNumber="setPageDisplay"
        @pageSize="setNumDisplay"
      />
    </section>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import TableFilter from "./module/TableFilter.vue";
import QuoteTable from "./module/QuoteTable.vue";
import PaginationControl from "@/components/UI/pagination";


export default {
  components: {
    PaginationControl,
    TableFilter,
    QuoteTable,
    PageHeader,
  },
  data() {
    return {
      allQuotes: [],
      isLoading: false,
      pageNumber: 1,
      pageSize: 10,
     
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        interval: "month",
        startDate: "2025-02-25",
        endDate: "2025-02-25",
        searchString: "",
      },
    };
  },
  computed: {
    payload() {
      return {
        status: "quote",
        searchTerm: "",
        pageSize: this.pageSize,
        interval: this.sortOptions.interval,
        startDate: this.sortOptions.startDate,
        endDate: this.sortOptions.endDate,
        pageNumber: this.pageNumber,
        customerType: "consumer",
        // shippingReference: "",
        
      };
    },
  },
  watch: {
    payload() {
      this.getAllQuoteAndDraft();
    },
  },
  mounted() {
    this.getAllQuoteAndDraft();
  },
  methods: {
     sortSearchString(val) {  
      if (val.length === 6 ) {
        this.payload.searchTerm = val  
        this.getAllQuoteAndDraft(); 
      } else if (!val.length) {
        this.payload.searchTerm = ""  
        this.getAllQuoteAndDraft();
      }
    },

    filterProps(val) {
      this.sortOptions.interval = val
      this.getAllQuoteAndDraft();       
    },
    sortItemProps(val) {
      this.payload.interval = val.interval
      this.payload.startDate = val.startDate
      this.payload.endDate = val.endDate
      this.getAllQuoteAndDraft(); 
    },
    setPageDisplay(val) {
      this.pageNumber = val;
    },
    setNumDisplay(val) {
      this.pageSize = val;
    },
   
    async getAllQuoteAndDraft() {
      try {
        this.isLoading = true;
        await this.$_getQuoteAndDraftCustomer(this.payload)
        .then((response) => {
          this.allQuotes = response.data.data;
        });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
i{
  color : #10233E;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #FFA600;
  box-shadow: #FFA6001A;
  background: #FFA6001A;
  border-radius: 8px;
  width: 50%;
}
.unit-point {
  @apply flex items-center shadow-lg px-4 py-2 rounded-lg;
}
.get-quote {
  @apply px-5 bg-primary-yellow py-3 rounded-lg;
}
a {
  color: inherit;
}
</style>
